export const TokenRetrieverAllowedToolsList = Object.freeze([
    'ihm_prep_and_receive_tool', // Prep and Receive Tool
    'counter_tool', // Counter tool
    'counter_return_only_tool', // Counter Return Only Tool
    'deliver_tool', // Ihm Deliver Tool
    'pick_tool', // Ihm Pick Tool
    'shelf_install', // Shelf Install, CTI : Ihm/Tools/TechBringupTool
    'camera_install', // Camera Install, CTI : Ihm/Tools/TechBringupTool
    'calibration_dashboard', // Calibration Dashboard, CTI : Ihm/Tools/TechBringupTool
    'aos_install', // Add-on Sensor Install, CTI : Ihm/Tools/TechBringupTool
    'grocery_checkin_tool', // Task UI Grocery Checkin Tool, CTI: F3/Associate Experience/Planning
    'utr_unpack_tool', // Task UI Unpack Tool, CTI: F3/Associate Experience/Planning
    'grocery_site_assistant_tool', // Site Assist, CTI: WWGST/UTRT/Site Assistant
])
